import React from "react"
import badge from "badges/information-analysis.svg"
import { BadgeImage } from "backpack/badges/styled"

const InformationAnalysis = props => <BadgeImage src={badge} {...props} />

export default InformationAnalysis
